module.exports = __webpack_public_path__ + "html/subscription-alert_9c9e0d89e7f6547e20bee94547b7b514.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/subscription-alert.html
// module id = P9ky
// module chunks = 60